import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/author/_author/editorial-team/_editorialTeam')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.editorialTeams' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
